var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('v-chip',_vm._g(_vm._b({attrs:{"small":"","color":_vm.getColor(_vm.item.status)}},'v-chip',attrs,false),on))]}}])},[_c('span',[_vm._v(" "+_vm._s(_vm.fillToolTips(_vm.item.status))+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }